import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid2x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDotGrid2x3"><Path d="M7.5 4H11V7.5H7.5V4Z" fill="currentColor"/><Path d="M13 4H16.5V7.5H13V4Z" fill="currentColor"/><Path d="M7.5 16.5H11V20H7.5V16.5Z" fill="currentColor"/><Path d="M13 16.5H16.5V20H13V16.5Z" fill="currentColor"/><Path d="M7.5 10.15H11V13.75H7.5V10.15Z" fill="currentColor"/><Path d="M13 10.15H16.5V13.75H13V10.15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid2x3;
